import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "addOne" })
export class AddOnePipe implements PipeTransform {
    transform(value: string): any {
        if (!value) { return value; }
        let num = +value;
        return num++;
    }
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/common/add-one.pipe.ts